import type { z } from 'zod';
import { prioritySchema } from '@/entities/shared/priority/priority';
import { isoDateField } from '@/entities/shared/schemas/iso-date-field';
import { longTextField } from '@/entities/shared/schemas/long-text-field';
import { nameField } from '@/entities/shared/schemas/name-field';
import { zs } from '@/entities/shared/schemas/zod';
import { checklistStepSchema } from './checklist-step';
import { repeatUnitSchema } from './repeat-unit';
import { taskKindSchema } from './task-kind';
import { taskStatusSchema } from './task-status';

/** An action, a recommendation or a periodic check. Mirrors …/collections/task.py. */
export const taskSchema = zs.looseObject({
  title: nameField,
  kind: taskKindSchema.default('action'),
  status: taskStatusSchema.default('todo'),
  priority: prioritySchema.default('medium'),
  /** Before this date the task cannot be done yet (waiting for a parcel, a season). */
  starts_on: isoDateField.optional(),
  due_on: isoDateField.optional(),
  /** Days before `due_on` to start warning; absent: only on the day (decision 0012). */
  remind_days: zs.number().int().min(0).max(365).optional(),
  done_on: isoDateField.optional(),
  repeat_every: zs.number().int().min(1).max(365).optional(),
  /** Absent: months. */
  repeat_unit: repeatUnitSchema.optional(),
  /** Absent when the task has no steps. */
  checklist: zs.array(checklistStepSchema).min(1).max(100).optional(),
  notes: longTextField.optional(),
});

export type Task = z.infer<typeof taskSchema>;
